export const PARAM_LIST_SEPARATOR = ",";
export const MULTISTOP_IATA_LIST_SEPARATOR = "|";
